import { ReactNode } from 'react';
import { Container } from '@mui/material';
import { DataGridContainerProps } from './types';
import { dataGridContainerSx } from './styles';

export function DataGridContainer({
  children,
  ...props
}: DataGridContainerProps): ReactNode {
  return (
    <Container
      {...props}
      disableGutters
      maxWidth={false}
      sx={dataGridContainerSx}
    >
      {children}
    </Container>
  );
}
